import React, { useEffect, useState } from 'react';
import { styled, SwipeableDrawer } from '@mui/material';
import { useLocation } from 'react-router-dom';

const drawerBleeding = 21;

const SwipeDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  zIndex: theme.zIndex.swipeDrawer,
  '&.MuiDrawer-root > .MuiPaper-root': {
    height: `calc(100% - ${drawerBleeding}px)`,
    overflow: 'visible',
  },

}));

// This drawer IS the side nav below `md`, so it takes the side nav's surface.
const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.sideNavBackground,
}));

const Puller = styled('div')(({ theme }) => ({
  width: 80,
  height: 4,
  backgroundColor: (theme.vars || theme).palette.iconMuted,
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 40px)',
}));

/**
 * @param {Object} props
 * @param {Object} props.content
 */
function EdgeSwipeDrawer({ content }) {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // Close the drawer on navigation
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return (
    <SwipeDrawer
      sx={{ display: { xs: 'block', md: 'none' } }}
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      swipeAreaWidth={drawerBleeding}
      disableSwipeToOpen={false}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <StyledBox
        sx={{
          position: 'absolute',
          top: -drawerBleeding,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          borderBottomLeftRadius: 3,
          borderBottomRightRadius: 3,
          visibility: 'visible',
          right: 0,
          left: 0,
          height: 25,
        }}
      >
        <Puller />
      </StyledBox>
      <StyledBox sx={{
        px: 2, pt: 4, pb: 2, height: '100%', overflow: 'auto',
      }}
      >
        {content}
      </StyledBox>
    </SwipeDrawer>
  );
}

export default EdgeSwipeDrawer;
